
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/attorneys",
      function () {
        return require("private-next-pages/attorneys/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/attorneys"])
      });
    }
  